export const newMapiRefreshTokenURL = '/jwt/refresh'
